import React from "react";

function Color_RGB() {
  return (
    <div>
      <h1>Color_RGB Component</h1>
      <p>This is the Color RGB tutorial page content.</p>
    </div>
  );
}

export default Color_RGB;
